/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = Add

1 = Modify

2 = Remove

3 = CreateLink

4 = RemoveLink


 */
export type DraftItemChangeType =
  (typeof DraftItemChangeType)[keyof typeof DraftItemChangeType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DraftItemChangeType = {
  Add: 0,
  Modify: 1,
  Remove: 2,
  CreateLink: 3,
  RemoveLink: 4,
} as const;
